export const orderPlacedMessage = publicOrderNumber =>
  publicOrderNumber
    ? `Order ${publicOrderNumber} has been placed.`
    : 'Your order has been placed.'



// WEBPACK FOOTER //
// ./src/utils/orderConfirmation.js